export const allArticles = [
  {
    id: 'new-version-2-0',
    slug: 'new-version-2-0',
    title: '「樱境物语」2.0版本「花影篇」正式上线',
    excerpt: '全新剧情章节、两位新角色加入，樱境世界迎来重大更新。探索花影背后的秘密，揭开樱境隐藏千年的真相。',
    content: `<p>亲爱的樱境旅人们：</p>
<p>经过数月精心打磨，我们非常激动地宣布——<strong>「樱境物语」2.0版本「花影篇」</strong>正式上线！</p>
<h3>全新剧情：花影之谜</h3>
<p>在樱境的深处，有一片被称为「花影之森」的禁地。传说中，那里封印着樱境最古老的秘密。随着一股神秘力量的苏醒，花影之森的封印开始松动，樱姬感应到了前所未有的危机。</p>
<p>新剧情线将带你深入花影之森，揭开千年前樱境创立之初的真相。你会发现，樱境的命运远比你想象的更加复杂……</p>
<h3>两位全新角色登场</h3>
<p><strong>影</strong> —— 来自花影之森的神秘少女，拥有操控影子的能力。沉默寡言，却对樱境的秘密了如指掌。</p>
<p><strong>枫</strong> —— 流浪的武士，为了寻找失踪的妹妹而来到樱境。性格豪爽直率，剑术高超。</p>
<h3>系统优化</h3>
<p>本次更新还包括大量系统优化：战斗系统平衡调整、新增羁绊回忆系统、UI界面全面焕新、性能大幅提升。</p>
<p>现在就更新游戏，开启全新的花影之旅吧！</p>`,
    category: '故事',
    categorySlug: 'story',
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20cherry%20blossom%20landscape%20with%20ancient%20Japanese%20temple%20in%20the%20distance%2C%20magical%20cherry%20petals%20floating%2C%20warm%20golden%20sunset%20lighting%2C%20mystical%20atmosphere%2C%20illustration%20style%20clean%20composition&width=800&height=450&seq=sakura-article-01&orientation=landscape',
  },
  {
    id: 'character-guide-sakura-hime',
    slug: 'character-guide-sakura-hime',
    title: '角色深度解析：樱姬的培养路线与剧情分支全攻略',
    excerpt: '全方位解析核心角色「樱姬」的养成策略、技能搭配以及隐藏剧情分支，助你解锁全部故事线。',
    content: `<p>樱姬作为樱境物语的核心角色，她的成长路线直接影响着整个故事的走向。本文将为你详细解析樱姬的培养策略。</p>
<h3>基础属性分析</h3>
<p>樱姬的定位是<strong>元素法师/辅助</strong>，拥有极高的魔法攻击力和优秀的群体治疗能力。她的核心属性优先级为：魔法攻击 > 速度 > 生命值。</p>
<h3>技能搭配推荐</h3>
<p><strong>日常推图配置：</strong>樱花缭乱 + 樱雨祝福 + 花之守护。这套组合兼顾了AOE输出和团队续航。</p>
<p><strong>Boss战配置：</strong>樱华绽放 + 生命之樱 + 樱花结界。单体爆发配合减伤，适合高强度战斗。</p>
<h3>剧情分支关键节点</h3>
<p>樱姬共有3条主要剧情线，取决于你在第3章和第7章的关键选择。想要解锁隐藏结局「永恒之樱」，需要在所有关键节点都选择「信任」选项。</p>
<h3>专属装备获取</h3>
<p>樱姬的专属武器「樱华扇」可在完成第10章后，通过支线任务「樱之试炼」获得。建议在70级以上挑战。</p>`,
    category: '玩法攻略',
    categorySlug: 'guide',
    date: '2026-08-05',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20closeup%20of%20pink%20haired%20goddess%20character%20surrounded%20by%20magical%20cherry%20blossoms%2C%20detailed%20character%20art%2C%20soft%20glowing%20light%2C%20ethereal%20beauty%2C%20illustration%20with%20intricate%20details&width=800&height=450&seq=sakura-article-02&orientation=landscape',
  },
  {
    id: 'plot-analysis-chapter-5',
    slug: 'plot-analysis-chapter-5',
    title: '剧情深度剖析：第五章「樱落之时」隐藏伏笔全解读',
    excerpt: '逐帧分析第五章中的隐藏细节与伏笔，揭示编剧埋下的惊天秘密。这些细节你注意到了吗？',
    content: `<p>第五章「樱落之时」是整部作品的重要转折点。表面上是一场浪漫的樱花祭典，实际上编剧在这章埋下了大量伏笔。</p>
<h3>樱花树下的对话</h3>
<p>仔细分析樱姬与剑心在古樱树下的对话，你会发现剑心提到的「那个人」并非指代敌人，而是指向了一个尚未登场的关键角色。这段对话中剑心的三次沉默，分别对应了后续三章的核心冲突。</p>
<h3>祭典中的暗号</h3>
<p>樱花祭典上的灯笼排列并非随意设计。将灯笼的颜色顺序与古代樱境文字对照，可以解读出一段预言——「当七色樱花同时绽放，门扉将再次开启」。这个伏笔将在第七章得到呼应。</p>
<h3>隐藏CG触发条件</h3>
<p>第五章有三张隐藏CG，触发条件分别是在特定时间点选择「独自行动」、在祭典上与所有可交互NPC对话、以及在剧情结尾选择「回头」。第三张CG揭示的画面直接暗示了最终Boss的身份。</p>`,
    category: '剧情',
    categorySlug: 'plot',
    date: '2026-07-28',
    readTime: '15分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20dramatic%20scene%20of%20cherry%20blossoms%20falling%20in%20twilight%2C%20silhouettes%20of%20two%20figures%20standing%20under%20ancient%20cherry%20tree%2C%20emotional%20atmosphere%2C%20deep%20warm%20colors%2C%20illustration%20cinematic%20composition&width=800&height=450&seq=sakura-article-03&orientation=landscape',
  },
  {
    id: 'kenshin-backstory',
    slug: 'kenshin-backstory',
    title: '角色秘话：剑心——樱花与剑的羁绊',
    excerpt: '深入探索流浪剑客剑心的前世今生，揭示他手中那把名为「樱切」的名刀背后的故事。',
    content: `<p>剑心，这位沉默寡言的流浪剑客，是许多玩家心中最具魅力的角色之一。今天，让我们一起揭开他尘封的过去。</p>
<h3>樱切的由来</h3>
<p>剑心手中的名刀「樱切」，是由樱境第一代刀匠「铁心」以千年樱木为核心锻造而成。这把刀不仅锋利无比，更与樱境的生命之源紧密相连。每当剑心挥动樱切，刀身都会绽放出淡淡的樱花纹样。</p>
<h3>失落的家族</h3>
<p>剑心出身于樱境古老的剑术家族「心剑流」，这个家族世代守护樱境的和平。然而十五年前的一场浩劫，整个家族在一夜之间消失。年幼的剑心是唯一的幸存者。</p>
<h3>与樱姬的初遇</h3>
<p>在游戏的隐藏回忆片段中，可以看到剑心与樱姬在童年时期其实已经相遇过。那个樱花飘落的午后，成为了两人命运交织的起点。</p>`,
    category: '角色',
    categorySlug: 'characters',
    date: '2026-07-20',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20samurai%20character%20holding%20katana%20with%20cherry%20blossom%20petals%20swirling%20around%20the%20blade%2C%20dramatic%20stance%2C%20traditional%20Japanese%20temple%20background%2C%20warm%20evening%20light%2C%20illustration%20cinematic%20composition&width=800&height=450&seq=sakura-article-04&orientation=landscape',
  },
  {
    id: 'new-player-guide',
    slug: 'new-player-guide',
    title: '新手必看：樱境物语入门全指南',
    excerpt: '刚踏入樱境世界？这份保姆级入门指南帮你快速上手，少走弯路，享受最完美的游戏体验。',
    content: `<p>欢迎来到樱境世界！如果你是第一次接触樱境物语，这篇指南将帮助你快速上手。</p>
<h3>选择你的起点</h3>
<p>游戏开始时，你需要选择一位初始伙伴。新手推荐选择<strong>樱姬</strong>，她的治疗能力能让你在前期更加从容。如果想挑战高难度，可以选择剑心体验不一样的战斗风格。</p>
<h3>资源管理技巧</h3>
<p>前期的樱花露（经验道具）非常珍贵，建议优先提升主力角色的等级。金币主要用于装备强化，不要浪费在商店购买消耗品上。</p>
<h3>每日必做任务</h3>
<p>1. 樱花试炼（经验获取）<br/>2. 羁绊之约（好感度提升）<br/>3. 秘境探索（稀有素材）<br/>完成这三项日常，你就能稳步提升战力。</p>
<h3>避坑指南</h3>
<p>不要在前期过度分散培养角色，集中资源培养3-4位核心角色。剧情分支的选择不可逆，关键节点记得多存档。</p>`,
    category: '玩法攻略',
    categorySlug: 'guide',
    date: '2026-07-12',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20new%20adventurer%20standing%20at%20the%20entrance%20of%20a%20magical%20cherry%20blossom%20world%2C%20looking%20amazed%2C%20backpack%20and%20adventure%20gear%2C%20soft%20warm%20lighting%2C%20welcoming%20atmosphere%2C%20illustration%20style&width=800&height=450&seq=sakura-article-05&orientation=landscape',
  },
  {
    id: 'soundtrack-interview',
    slug: 'soundtrack-interview',
    title: '音乐制作人访谈：樱境物语原声音乐背后的故事',
    excerpt: '专访樱境物语音乐总监林和也，揭秘那些触动人心的旋律是如何诞生的。',
    content: `<p>樱境物语的原声音乐自发布以来，在各大音乐平台累计播放量突破2000万次。本次我们有幸专访了音乐总监林和也先生。</p>
<h3>创作理念</h3>
<p>「樱境物语的音乐不仅仅是背景音乐，它本身就是叙事的一部分。」林和也表示，每一首曲目都对应了特定的剧情节点和角色情绪。主题曲《千年樱》的创作历时三个月，融合了日本传统雅乐与现代管弦乐。</p>
<h3>乐器选择</h3>
<p>原声带使用了超过30种乐器，包括尺八、三味线、筝等传统和乐器，以及完整的交响乐团编制。林和也特别提到：「尺八的音色最能表达樱花的凄美，而三味线则为战斗场景注入了力量。」</p>
<h3>灵感来源</h3>
<p>「樱花的生命短暂却绚烂，这正是我想用音乐表达的。」林和也分享道，他在京都的樱花季节住了整整一个月，每天在古寺中感受樱花飘落的瞬间，这些体验都成为了创作的源泉。</p>`,
    category: '故事',
    categorySlug: 'story',
    date: '2026-06-30',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20music%20composer%20sitting%20at%20piano%20surrounded%20by%20cherry%20blossom%20petals%2C%20traditional%20Japanese%20instruments%20in%20background%2C%20warm%20soft%20lighting%2C%20creative%20atmosphere%2C%20illustration%20artistic%20style&width=800&height=450&seq=sakura-article-06&orientation=landscape',
  },
];

export const categories = [
  { slug: 'story', label: '故事', icon: 'ri-book-open-line', description: '探索樱境世界的最新故事与剧情更新' },
  { slug: 'characters', label: '角色', icon: 'ri-user-heart-line', description: '了解樱境中每一位角色的故事与秘密' },
  { slug: 'guide', label: '玩法攻略', icon: 'ri-gamepad-line', description: '从新手到高手，全方位的玩法指南' },
  { slug: 'plot', label: '剧情', icon: 'ri-movie-line', description: '深度解析每一章的剧情与隐藏伏笔' },
];